import { Box } from '@mui/material';
import XCloseIcon from '../../../components/Icons/x-close-icon';

const ModalX = ({ close }: { close: VoidFunction }) => (
  <Box
    position={'absolute'}
    right={20}
    top={20}
    padding={'4px'}
    alignItems={'center'}
    height={'32px'}
    justifyContent={'center'}
    borderRadius={'100px'}
    sx={{ backgroundColor: '#14191F0D', cursor: 'pointer' }}
    onClick={close}
  >
    <XCloseIcon />
  </Box>
);

export default ModalX;
